import {
	AgreementBusinessModel,
	AgreementServiceType,
	ServiceAgreementStatus,
} from 'api';
import { ParseKeys, TOptions } from 'i18next';

export const serviceAgreementStatusToTranslationMapping: {
	[K in ServiceAgreementStatus]: ParseKeys<
		['unitOverview'],
		TOptions,
		'unitOverview'
	>;
} = {
	Active: 'unitOverview:service-agreement-active',
	Annulate: 'unitOverview:service-agreement-annulate',
	Expired: 'unitOverview:service-agreement-expired',
	Planned: 'unitOverview:service-agreement-planned',
};

export const agreementServiceTypeToTranslationMapping: {
	[K in AgreementServiceType]: ParseKeys<
		['unitOverview'],
		TOptions,
		'unitOverview'
	>;
} = {
	Base: 'unitOverview:service-agreement-service-type-base',
	Comfort: 'unitOverview:service-agreement-service-type-comfort',
	Advanced: 'unitOverview:service-agreement-service-type-advanced',
	Others: 'unitOverview:service-agreement-service-type-others',
	SLA: 'unitOverview:service-agreement-service-type-sla',
};

export const agreementBusinessModelToTranslationMapping: {
	[K in AgreementBusinessModel]: ParseKeys<
		['unitOverview'],
		TOptions,
		'unitOverview'
	>;
} = {
	BM1: 'unitOverview:service-agreement-business-model-one',
	BM2: 'unitOverview:service-agreement-business-model-two',
};
